import React, { useEffect, useState } from "react";
import TextAreaField from "../../forms/textarea-field";
import InputField from "../../forms/input-field";
import { useDispatch } from "react-redux";
import SelectField from "../../forms/select-field";
import { stateListAction, pincodeListAction } from "../../../redux/actions/general-action";
import { useFormikContext } from "formik";

const StoreFirmShopAddressTab = ({ disabled = false }) => {
  const dispatch = useDispatch();
  const { values, setFieldValue } = useFormikContext();

  const [stateList, setStateList] = useState([]);

  useEffect(() => {
    dispatch(stateListAction(onSuccessState, onErrorState));
  }, []);

  const onSuccessState = (data) => {
    setStateList(
      data.map((item) => {
        return { label: item?.name, value: item?.name };
      })
    );
  };
  const onErrorState = () => {};

  function fetchCountryFromPincode(pincode) {
    if (pincode?.length === 6) {
      dispatch(
        pincodeListAction(
          pincode,
          (response) => {
            if (response?.[0]?.Status !== "Error") {
              const postOffice = response?.[0]?.PostOffice?.[0];
              const country = postOffice?.Country ?? "";
              setFieldValue("firm_country_region", country.toLowerCase() === "india" ? "india" : country || "india");
              setFieldValue("firm_region", postOffice?.District ?? "");
            }
          },
          () => {}
        )
      );
    } else {
      setFieldValue("firm_country_region", "");
      setFieldValue("firm_region", "");
    }
  }

  useEffect(() => {
    if (values.firm_pin_code?.length === 6) {
      fetchCountryFromPincode(values.firm_pin_code);
    }
  }, [values.firm_pin_code]);
  return (
    <div className="w-full 2xl:w-[30%] lg:w-[60%] px-5 xl:px-10">
      <TextAreaField
        isDisabled={disabled}
        label="Firm Address"
        placeholder="Enter Firm Address"
        name="firm_address"
        id={"firm_address"}
        // isRequired={true}
        labelWidth="8.5rem"
        feildHeight="5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="firm_area"
        placeholder="Enter Firm Area"
        label="Firm Area"
        labelWidth="8.5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="firm_landmark"
        placeholder="Enter Firm Landmark"
        label="Firm Landmark"
        labelWidth="8.5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="firm_town_or_village"
        placeholder="Enter Firm Town/ Village"
        label="Firm Town/ Village"
        labelWidth="8.5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="firm_city"
        placeholder="Firm City"
        label="Firm City"
        labelWidth="8.5rem"
      />
      <SelectField
        isDisabled={disabled}
        placeholder={"Select state"}
        options={stateList}
        label={"Select State"}
        id={"firm_state"}
        name="firm_state"
        isSearchable={true}
        errMsgContainerClass="ps-2"
        // isRequired={true}
        labelWidth="8.5rem"
      />

      <SelectField
        isDisabled={disabled}
        placeholder={"Select country"}
        options={countryList}
        label={"Country"}
        id={"firm_country_region"}
        name="firm_country_region"
        isSearchable={true}
        errMsgContainerClass="ps-2"
        labelWidth="8.5rem"
      />
      <InputField
        isDisabled={disabled}
        type="text"
        name="firm_region"
        placeholder="Enter Region"
        label="Region"
        labelWidth="8.5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="firm_pin_code"
        placeholder="Enter Firm Pin Code"
        label="Firm Pin Code"
        labelWidth="8.5rem"
        handleChange={(e) => fetchCountryFromPincode(e?.target?.value)}
      />
    </div>
  );
};

export default StoreFirmShopAddressTab;

const countryList = [{ label: "India", value: "india" }];